module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Snow1-e7ea484cfc220a203dd2280270665b46.svg";